import Vue from 'vue';
import axios from 'axios';
import { get } from 'lodash';
import lazyLoadGrid from './components/lazy-load-grid';
import educationCard from './components/education-card';

export default (() => {
    if (document.querySelector('#education-grid')) {
        new Vue({
            el: '#education-grid',

            delimiters: ['${', '}'],

            components: {
                lazyLoadGrid,
                educationCard,
            },

            data: {
                courses: [],
                isSearching: true,
                searchQuery: (new URLSearchParams(window.location.search)).get('search') || ''
            },

            computed: {
                offset() {
                    return this.courses.length;
                },
            },

            created() {
                axios.get(`/api/education.json?search=${this.searchQuery}`)
                    .then((response) => {
                        this.courses = get(response, 'data.data');
                    })
                    .finally(() => {
                        this.isSearching = false;
                    });
            },

            methods: {
                loadMore() {
                    this.isSearching = true;
                    axios.get(`/api/education.json?offset=${this.offset}&search=${this.searchQuery}`)
                        .then((response) => {
                            this.courses.push(get(response, 'data.data'));
                        })
                        .finally(() => {
                            this.isSearching = false;
                        });
                },
            },
        });
    }
})();
